module.exports = __webpack_public_path__ + "static/img/logo.4292b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 16